//import react from 'react';
import { Col } from 'reactstrap';

export default function ColValue({ size, ...props }) {
	return (<Col xxl={size || 6} xl={5} lg={5}>{props.children}</Col>);
}